"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var EarlyAccessStore = /*#__PURE__*/function (_RootStore) {
  function EarlyAccessStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, EarlyAccessStore);
    _this = _callSuper(this, EarlyAccessStore);
    _this.config = {
      model: _models.Site,
      GET: {
        validateToken: '/early_access/validate_token'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(EarlyAccessStore, _RootStore);
  return (0, _createClass2["default"])(EarlyAccessStore, [{
    key: "validateTokenPromise",
    value: function () {
      var _validateTokenPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(token) {
        var params;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                queryStrings: {
                  token: token
                }
              };
              _context.next = 1;
              return this.apiPromise(params, 'GET', 'validateToken');
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function validateTokenPromise(_x) {
        return _validateTokenPromise.apply(this, arguments);
      }
      return validateTokenPromise;
    }()
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new EarlyAccessStore();